module.exports = __webpack_public_path__ + "static/media/bgMyProfilePage.afc893ce.jpg";